import { LanguageEnum } from 'utils/constants';
import { post } from 'utils/sdk';

export const setSelfUserPassword = ({
  token,
  email,
  password,
  passwordConfirmation,
  locale = 'en',
}: {
  token: string;
  email: string;
  password: string;
  passwordConfirmation: string;
  locale?: string;
}) =>
  post<{ message: string }>('api/v2/auth/set-password', {
    token,
    email,
    password,
    password_confirmation: passwordConfirmation,
    locale,
  });

export const resetSelfUserPassword = ({ token, email, password }: { token: string; email: string; password: string }) =>
  post('api/v2/auth/reset-password', {
    token,
    email,
    password,
    password_confirmation: password,
  });

export const isUserTokenValid = ({ email, token }: { email: string; token: string }) =>
  post('api/v2/auth/is-user-token-valid', {
    token,
    email,
  });

export const sendForgotPasswordEmail = ({ email }: { email: string }) =>
  post('api/v2/auth/send-forgot-password-email', {
    email,
  });

export interface ILoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export const login = ({ email, password, locale = 'en' }: { email: string; password: string; locale?: string }) =>
  post<ILoginResponse>('api/customer-facing/login', { email, password, locale });

export interface ILogoutResponse {
  message: string;
}
export const logout = () => post<ILogoutResponse>('api/customer-facing/logout', {});

export interface IUserProfile {
  id: number;
  email: string;
  name: string;
  language_preference: LanguageEnum;
}

export const setUserLanguagePreference = ({ language }: { language: LanguageEnum }) =>
  post('api/customer-facing/set-user-language-preference/', {
    language,
  });
